<template>
<div>

	<!-- page header -->
    <page-heading :show="true" :pageTitle="$t('CALENDAR-HEADER')"></page-heading>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<div class="columns" v-if="!isLoading">

        <div class="col-main">

            <!-- TODO: @andreas CAN() ...  v-if="can('CALENDAR.SELECT_SITE')"> -->
            <multiselect v-if="activeUser && activeUser.userRole.name != 'Apotheke'"
                v-model="pharmacy"
                :options="pharmacies"
                :custom-label="customLabel"
                :allow-empty="true"
                selected-label="aktiv"
                deselect-label="Klick um abzuwählen"
                select-label="Klick für Auswahl"
                placeholder="Suche nach Apotheke"
                label="name"
                track-by="id"
                :optionsLimit="10"
                style="margin-bottom:15px;">
                <span slot="noResult">Ihre Suche ergab leider keine Treffer.</span>
            </multiselect>


            <tabs type="boxed" size="normal" :on-tab-click="tabCallback" :key="pharmacy">

                <!-- tab: Kalender -->
                <tab-item :label="$t('CALENDAR-TAB-CALENDAR')">
                    <!-- <calendar :apoId="pharmacy != null ? pharmacy.id : null" :isPro="pharmacyIsPro"></calendar> -->
                    <calendar :pharmacy="pharmacy" :isPro="pharmacyIsPro"></calendar>
                </tab-item>

                <!-- tab: to do's -->
                <tab-item :label="$t('CALENDAR-TAB-TODOS')" v-if="pharmacyIsPro">
                    <calendar-todos v-if="this.activeTab == 1" :pharmacy="pharmacy"></calendar-todos>
                </tab-item>

                <!-- tab: DOKUMENTE -->
                <tab-item :label="$t('CALENDAR-TAB-DOCUMENTS')" v-if="pharmacyIsPro">
                    <calendar-documents v-if="this.activeTab == 2" :pharmacy="pharmacy"></calendar-documents>
                </tab-item>

                <!-- tab: UPLOADS -->
                <tab-item :label="$t('CALENDAR-TAB-UPLOADS')" v-if="pharmacyIsPro">
                    <calendar-uploads v-if="this.activeTab == 3" :pharmacy="pharmacy"></calendar-uploads>
                </tab-item>

                <!-- tab: PRINTSHOP -->
                <tab-item :label="$t('CALENDAR-TAB-PRINTSHOP')" v-if="pharmacyIsPro">
                    <calendar-printshop v-if="this.activeTab == 4" :apoId="pharmacy != null ? pharmacy.id : null"></calendar-printshop>
                </tab-item>

            </tabs>

        </div>

	</div>

</div>

</template>


<script>
import calendar from './incl-calendar';
import Multiselect from 'vue-multiselect'
import calendarTodos from './incl-calendar-todos';
import calendarDocuments from './incl-calendar-documents';
import calendarUploads from './incl-calendar-uploads';
import calendarPrintshop from './incl-calendar-printshop';

export default {

	name: 'marketingCalendar',

	components: {
        calendar,
        calendarTodos,
        calendarDocuments,
        calendarUploads,
        calendarPrintshop,
        Multiselect
	},

	data() {

		return {
			isLoading: true,
            pharmacies: [],
            pharmacy: null,
            isPro: false,
            activeTab: 0
		}
	},

	created() {

        if(this.activeUser && ['Administrator', 'Administrator JTM', 'HC Marketing'].indexOf(this.activeUser.userRole.name) > -1) {

            this.fetchPharmacies();
            this.pharmacyIsPro = true;

        } else {

            if(this.activeUser && this.activeUser.userRole.name == 'Apotheke' && this.activeUser.site) {

                this.pharmacy = this.activeUser.site;
                this.pharmacyIsPro = this.pharmacy.marketingPlan != 'BASIC';
                this.isLoading = false;

            }

        }

	},


	mounted() {

	},

	methods: {

        tabCallback(i) {

            this.activeTab = i;

        },

        customLabel({ name, city, zipcode, extRef }) {

            return name + ' (#'+extRef+')';

        },

		fetchPharmacies() {

			var self = this;

            this.axios.get(self.$config.api + 'site?fields=name,extRef,mandate,marketingPlan,marketingChannelCustomizations__JSON&orderBy=name')
				.then(function(response) {

				    self.pharmacies = response.data.site;
                    self.isLoading = false;

				}).catch(function(error) {
					console.log('Error: ', error.message);
				});

		}


	}

}
</script>

<style scoped>
.tab-pane a {
    text-decoration: none;
    display: inline;
    border: none;
    margin: 0;
    padding: 0;
    vertical-align: inherit;
    color: #333;
}
.tab-pane a:hover {
    color: #000;
}
.tab-pane a .icon {
    vertical-align: middle;
}
body {
    overflow-y: scroll !important;
}
</style>
